import {Component, OnInit, Output, EventEmitter, AfterViewInit} from '@angular/core';
import {TopicService} from "../../../../service/forum/topic.service";
import {Topic} from "../../../../domain/topic";
import {forEach} from "@angular/router/src/utils/collection";
import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/debounceTime';

@Component({
    selector: 'topic-filter',
    templateUrl: './topic-filter.component.html',
    styleUrls: ['./topic-filter.component.scss'],
    providers: [TopicService]
})
export class TopicFilterComponent implements OnInit, AfterViewInit {

    public topics: Topic[] = null;

    $topicSearch: Subject<string> = new Subject();

    public selected: Topic = null;

    @Output() topicSelected = new EventEmitter<Topic>();

    public pageSize: number = 5;

    public page: Topic[] = null;

    public numberOfElements: number = 0;

    public pageNumber: number = 0;

    constructor(private topicService: TopicService) {
    }

    ngOnInit() {

        this.$topicSearch
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term =>
                this.topicService.findByValue(term)
            )
            .catch(error => {
                console.log(error);
                return Observable.of<Topic[]>([]);
            })
            .subscribe( t => {
                if ( t.length > 0 ) {
                    this.topics = t;
                    this.pageNumber = 0;
                    this.page = this.topics.slice(0, this.pageSize);
                    this.numberOfElements = this.topics.length;
                }
            });
    }

    ngAfterViewInit(): void {
        this.$topicSearch.next("");
    }


    public topicClicked(t: Topic, checked: boolean, index: number) {
        this.selected = t;
        this.topicSelected.next(t);
    }

    public searchTopic(val :string){
        this.$topicSearch.next(val);
    }

    public changePage(page : number) {
        if ( ( page >= 0 ) && ( page < (this.numberOfElements / this.pageSize) ) ){
            this.pageNumber = page;

            let t : Topic[] = [];
            for (let i = (this.pageNumber*this.pageSize) ;( i < ((this.pageNumber*this.pageSize)+ this.pageSize) )&&( i < this.numberOfElements ); i++) {
                t.push(this.topics[i])
            }
            this.page = t;
        }
    }

    public isSelected(t : Topic) : boolean {
        if (this.selected){
            return this.selected.id == t.id;
        }
        return false;
    }


}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/topic/topic-filter/topic-filter.component.ts